module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//25.jpg?c2879ff0f710b04a68c4a9fc2495d0c2";